import React from 'react'
import { Divider } from '../atoms'

const VerticalProgressBar = ({mainclasses, child, titleclass, title}) => {
  return (
    <div className={`${mainclasses} border-gray-300`}>
      <div className={`${titleclass} text-gray-600`}>{title}</div>
      <Divider classes='w-full my-4' />
      <section className='py-5' class="timeline">
        <ul>
          {child}
        </ul>
      </section>
    </div>
  )
}

export default VerticalProgressBar